<template>
  <div>
    <div class="action-header">
        <div class="search-container">
            <div class="search-input mb-3">
                <v-text-field
                    v-model="search"
                    prepend-inner-icon="search"
                    :placeholder="this.$vuetify.lang.t('$vuetify.visitorActivity.searchText')"
                    solo dense hide-details
                    height="40px"
                    @keyup.enter="searchVisitorPunchLog()">
                </v-text-field>
                <v-btn
                    class="ml-3"
                    height="40"
                    color="primary"
                    outlined
                    @click="searchVisitorPunchLog()">
                    {{ $vuetify.lang.t('$vuetify.visitorActivity.search') }}
                </v-btn>
            </div>

            <div class="filter-input mt-3">
                <date-picker-range
                    class="mr-3"
                    v-model="dateRange" />
                <div class="ml-3 select-filter">
                    <v-select
                        @change="getVisitorPunchLogList()"
                        v-model="device"
                        :items="deviceList"
                        item-text="text"
                        item-value="value"
                        outlined dense
                        height="40"
                        background-color="#ffffff">
                    </v-select>
                </div>
            </div>
        </div>
        <div class="d-flex ml-3">
            <v-btn
                class="ml-3 btn-text-color"
                height="50"
                @click="genPdfReport()"
                color="#ff544a">
                {{ $vuetify.lang.t('$vuetify.visitorActivity.exportPDF') }}
            </v-btn>
            <v-btn
                class="ml-3 btn-text-color"
                height="50"
                @click="genExcelReport()"
                color="#139888">
                {{ $vuetify.lang.t('$vuetify.visitorActivity.exportExcel') }}
            </v-btn>
        </div>
    </div>
    <v-card class="content-container">
        <v-data-table
            :footer-props="{
                'items-per-page-options': [10, 20, 30, 50, 100]
            }"
            @page-count="pageCount = $event"
            :page.sync="page"
            :headers="headers"
            :options.sync="options"
            :server-items-length="total"
            :items="visitorsPunchLog"
            :loading="loading">
            <template v-slot:[`item.snap_f_path`]="{ item }">
                <div class="pointer icon-profile" @click="showImage(item.snap_f_path)">
                    <i class="fas fa-portrait"></i>
                </div>
            </template>
        </v-data-table>
    </v-card>
    <image-preview
        ref="imagePreview" />
  </div>
</template>

<script>
import ImagePreview from '@/components/ImagePreview'
import DatePickerRange from '@/components/DatePickerRange.vue'

export default {
    name: 'VisitorActivity',

    components: {
        ImagePreview,
        DatePickerRange
    },

    data () {
        return {
            search: '',
            pageCount: 1,
            page: 1,
            options: {},
            visitorsPunchLog: [],
            total: 0,
            loading: false,
            deviceList: [],
            dateRange: [this.$dateUtil.getCurrentDate(), this.$dateUtil.getCurrentDate()],
            device: null
        }
    },

    computed: {
        dateData () {
            if (this.dateRange.length === 1) {
                return this.$dateUtil.formatDateData(this.dateRange[0], 1)
            } else if (this.dateRange.length === 2) {
                return `${this.$dateUtil.formatDateData(this.dateRange[0], 1)} - ${this.$dateUtil.formatDateData(this.dateRange[1], 1)}`
            } else {
                return ''
            }
        },

        headers () {
            return [
                { text: this.$vuetify.lang.t('$vuetify.visitorActivity.visitorName'), value: 'fullName', width: '20%' },
                { text: this.$vuetify.lang.t('$vuetify.visitorActivity.contact'), value: 'contact', width: '15%' },
                { text: this.$vuetify.lang.t('$vuetify.visitorActivity.contactNo'), value: 'contact_no', width: '15%' },
                { text: this.$vuetify.lang.t('$vuetify.visitorActivity.date'), value: 'date', width: '10%' },
                { text: this.$vuetify.lang.t('$vuetify.visitorActivity.time'), value: 'time', width: '10%' },
                { text: this.$vuetify.lang.t('$vuetify.visitorActivity.image'), value: 'snap_f_path', align: 'center', width: '10%' },
                { text: this.$vuetify.lang.t('$vuetify.visitorActivity.location'), value: 'device_name', width: '10%' },
                { text: this.$vuetify.lang.t('$vuetify.visitorActivity.temp'), value: 'temperature', width: '10%' }
            ]
        }
    },

    methods: {
        async getDeviceForFilter () {
            const res = await this.axios.get('visitor/punch-log/options')
            if (res && res.data && res.data.status === 'ok') {
                this.deviceList = res.data.data
            }
        },

        async searchVisitorPunchLog () {
            this.options.page = 1
            await this.getVisitorPunchLogList()
        },

        showImage (path) {
            this.$refs.imagePreview.toggleShow(path)
        },

        async getVisitorPunchLogList () {
            this.loading = true
            const { sortBy, sortDesc, page, itemsPerPage } = this.options

            let url = `visitor/punch-log-list?page=${page}&itemsPerPage=${itemsPerPage}`

            if (sortBy[0]) {
                url += `&sortBy=${sortBy[0]}`
            }

            if (sortDesc[0]) {
                url += `&sortDesc=${sortDesc[0]}`
            }

            if (this.search) {
                url += `&search=${this.search}`
            }

            if (this.device) {
                url += `&device=${this.device}`
            }

            if (this.dateRange) {
                if (this.dateRange.length === 1) {
                    url += `&startDate=${this.dateRange[0]}`
                } else if (this.dateRange.length === 2) {
                    url += `&startDate=${this.dateRange[0]}&endDate=${this.dateRange[1]}`
                }
            }

            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.visitorsPunchLog = res.data.data
                this.total = res.data.total
                this.loading = false
            } else {
                this.loading = false
            }
        },

        async genPdfReport () {
            const form = {
                search: this.search,
                dateRange: this.dateRange,
                location: this.device
            }
            localStorage.formData = JSON.stringify(form)
            const routeData = this.$router.resolve({ name: 'ReportVisitorActivityPDF' })
            window.open(routeData.href)
        },

        async genExcelReport () {
            await this.$store.dispatch('setLoading', true)
            const response = await this.axios.post(
                'visitor/punch-log/export/excel',
                {
                    search: this.search, dateRange: this.dateRange, location: this.device
                }, {
                    headers: { 'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
                    responseType: 'arraybuffer'
                })

            if (response && response.data) {
                const dateString = this.$dateUtil.getCurrentDate()
                this.$utils.downloadExcelFile(response.data, `visitor-activity-report-${dateString}.xlsx`)
            } else {
                await this.$store.dispatch('setErrorModalShow', true)
                await this.$store.dispatch('setErrorModalMsg', this.$vuetify.lang.t('$vuetify.visitorActivity.somethingWrong'))
            }
            await this.$store.dispatch('setLoading', false)
        }
    },

    async mounted () {
        await this.getDeviceForFilter()
        await this.getVisitorPunchLogList()
    },

    watch: {
        dateRange: {
            async handler () {
                if (this.dateRange.length === 0 || this.dateRange.length === 2) {
                    await this.searchVisitorPunchLog()
                }
            }
        },

        options: {
            async handler () {
                await this.getVisitorPunchLogList()
            },
            deep: true
        },

        '$vuetify.lang.current': {
            handler: async function () {
                await this.getDeviceForFilter()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.search-container {
    ::v-deep .v-input__control > .v-input__slot {
        min-height: auto !important;
        display: flex !important;
        align-items: center !important;
        box-shadow: none !important;
        border: 1px solid #a8a8a8 !important;
        width: 340px;
    }

    ::v-deep .search-input {
        align-items: center;
        .v-input__control > .v-input__slot {
            width: 340px;
        }
    }

    ::v-deep .date-range-input .v-input__control > .v-input__slot {
        width: 220px;
    }

    ::v-deep .status-filter {
        .v-input__control > .v-input__slot {
            border: none !important;
            width: 200px;
        }

        .v-select__selection{
            line-height: 1.75;
        }
    }
    ::v-deep .select-filter {
        .v-input__control > .v-input__slot {
            border: none !important;
            width: 200px;
        }

        .v-select__selection{
            line-height: 1.75;
        }
    }
}
.icon-profile {
    color: #d76436;
    font-size: 18px;
}
.btn-text-color {
    color: #ffffff;
}
</style>
